import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check-small",
  "use": "icon-check-small-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-check-small\"><path d=\"M14.773 23.65 9.4 18.063l1.445-1.933 3.577 3.37 6.436-9.885 1.865 1.285z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol